module.exports = __webpack_public_path__ + "static/office_image_1-6ae49a227160faf1b350a746f6743db5.jpg";